import { jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { Image } from '../Image/Image.esm.js';
import { cn } from '../../utils/cn.esm.js';

const DEFAULT_CARD_IMAGE_CONFIG = {
    width: 600,
    height: 400,
    alt: "Card image",
};
const isImageConfig = (val) => typeof val === "object" && val !== null && "src" in val;
const useCardImage = (image, baseClassName) => {
    return useMemo(() => {
        if (!image)
            return null;
        // React element passed directly
        if (React__default.isValidElement(image)) {
            // Cast element props to allow optional className
            const element = image;
            // Only append our class if the element doesn't already have one
            return React__default.cloneElement(element, {
                className: cn(element.props.className || "", baseClassName),
            });
        }
        // String => treat as src
        if (typeof image === "string") {
            return (jsx(Image, { src: image, alt: DEFAULT_CARD_IMAGE_CONFIG.alt, width: DEFAULT_CARD_IMAGE_CONFIG.width, height: DEFAULT_CARD_IMAGE_CONFIG.height, className: baseClassName }));
        }
        // Config object
        if (isImageConfig(image)) {
            const { src, alt = DEFAULT_CARD_IMAGE_CONFIG.alt, width = DEFAULT_CARD_IMAGE_CONFIG.width, height = DEFAULT_CARD_IMAGE_CONFIG.height, loading, className, } = image;
            return (jsx(Image, { src: src, alt: alt, width: width, height: height, loading: loading, className: cn(baseClassName, className) }));
        }
        return null;
    }, [image, baseClassName]);
};

export { DEFAULT_CARD_IMAGE_CONFIG, useCardImage };
